// useAdminAuth.js
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";

export const useAdminAuth = () => {
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Lấy custom claims từ token (force refresh để nhận claim mới nhất sau khi phân quyền)
        const tokenResult = await user.getIdTokenResult(true);
        // Hỗ trợ cả roles (array) và role (string)
        const claims = tokenResult.claims || {};
        const isAdminRole =
          (Array.isArray(claims.roles) && claims.roles.includes("admin")) ||
          claims.role === "admin";
        setIsAdmin(isAdminRole);
      } else {
        setIsAdmin(false);
      }
      setChecking(false);
    });

    return () => unsubscribe();
  }, []);

  return { checking, isAdmin };
};
